/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiChannelBindings } from '../models/AaiChannelBindings';
import { AaiChannelBindingsDefinition } from '../models/AaiChannelBindingsDefinition';
import { AaiChannelItem } from '../models/AaiChannelItem';
import { AaiComponents } from '../models/AaiComponents';
import { AaiCorrelationId } from '../models/AaiCorrelationId';
import { AaiDocument } from '../models/AaiDocument';
import { AaiHeaderItem } from '../models/AaiHeaderItem';
import { AaiMessage } from '../models/AaiMessage';
import { AaiMessageBase } from '../models/AaiMessageBase';
import { AaiMessageBindings } from '../models/AaiMessageBindings';
import { AaiMessageBindingsDefinition } from '../models/AaiMessageBindingsDefinition';
import { AaiMessageTrait } from '../models/AaiMessageTrait';
import { AaiMessageTraitDefinition } from '../models/AaiMessageTraitDefinition';
import { AaiOperation } from '../models/AaiOperation';
import { AaiOperationBase } from '../models/AaiOperationBase';
import { AaiOperationBindings } from '../models/AaiOperationBindings';
import { AaiOperationBindingsDefinition } from '../models/AaiOperationBindingsDefinition';
import { AaiOperationTrait } from '../models/AaiOperationTrait';
import { AaiOperationTraitDefinition } from '../models/AaiOperationTraitDefinition';
import { AaiParameter } from '../models/AaiParameter';
import { AaiSecurityScheme } from '../models/AaiSecurityScheme';
import { AaiServer } from '../models/AaiServer';
import { AaiServerBindings } from '../models/AaiServerBindings';
import { AaiServerBindingsDefinition } from '../models/AaiServerBindingsDefinition';
import { Document } from '../../core/models/Document';
import { AuthorizationCodeOAuthFlow } from '../../core/models/common/AuthorizationCodeOAuthFlow';
import { ClientCredentialsOAuthFlow } from '../../core/models/common/ClientCredentialsOAuthFlow';
import { Components } from '../../core/models/common/Components';
import { ImplicitOAuthFlow } from '../../core/models/common/ImplicitOAuthFlow';
import { OAuthFlows } from '../../core/models/common/OAuthFlows';
import { Operation } from '../../core/models/common/Operation';
import { PasswordOAuthFlow } from '../../core/models/common/PasswordOAuthFlow';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';
import { Server } from '../../core/models/common/Server';
import { ServerVariable } from '../../core/models/common/ServerVariable';
import { Traverser } from '../../core/visitors/Traverser';

/**
 * An AsyncAPI traverser implementation.
 * 
 * @author eric.wittmann@gmail.com
 * @author Jakub Senko <jsenko@redhat.com>
 * @param {*} visitor
 * @class
 * @extends Traverser
 */
export class AaiTraverser extends Traverser implements IAaiVisitor {
    public constructor(visitor : IAaiVisitor) {
        super(visitor);
    }

    /**
     * 
     * @param {Document} node
     */
    traverseDocument(node : Document) {
        super.traverseDocument(node);
        let aaiNode : AaiDocument = <AaiDocument>node;
        this.traverseCollection(aaiNode.getChannels());
        this.traverseCollection(aaiNode.getServers());
        this.traverseIfNotNull(aaiNode.components);
    }

    /**
     * 
     * @param {AuthorizationCodeOAuthFlow} node
     */
    public visitAuthorizationCodeOAuthFlow(node : AuthorizationCodeOAuthFlow) {
        this.traverseOAuthFlow(node);
    }

    /**
     * 
     * @param {AaiChannelItem} node
     */
    public visitChannelItem(node : AaiChannelItem) {
        node.accept(this.visitor);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
        this.traverseIfNotNull(node.subscribe);
        this.traverseIfNotNull(node.publish);
        this.traverseCollection(node.getParameterlist());
        this.traverseIfNotNull(node.bindings);
    }

    /**
     * 
     * @param {ClientCredentialsOAuthFlow} node
     */
    public visitClientCredentialsOAuthFlow(node : ClientCredentialsOAuthFlow) {
        this.traverseOAuthFlow(node);
    }

    /**
     * 
     * @param {Components} node
     */
    public visitComponents(node : Components) {
        let components : AaiComponents = <AaiComponents>node;
        node.accept(this.visitor);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
        this.traverseCollection(components.getMessagesList());
        this.traverseCollection(components.getSecuritySchemesList());
        this.traverseCollection(components.getParametersList());
        this.traverseCollection(components.getCorrelationIdsList());
        this.traverseCollection(components.getMessageTraitDefinitionsList());
        this.traverseCollection(components.getOperationTraitDefinitionsList());
        this.traverseCollection(components.getServerBindingsDefinitionList());
        this.traverseCollection(components.getChannelBindingsDefinitionList());
        this.traverseCollection(components.getOperationBindingsDefinitionList());
        this.traverseCollection(components.getMessageBindingsDefinitionList());
    }

    /**
     * 
     * @param {AaiCorrelationId} node
     */
    public visitCorrelationId(node : AaiCorrelationId) {
        node.accept(this.visitor);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * 
     * @param {AaiHeaderItem} node
     */
    public visitHeaderItem(node : AaiHeaderItem) {
        node.accept(this.visitor);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * 
     * @param {ImplicitOAuthFlow} node
     */
    public visitImplicitOAuthFlow(node : ImplicitOAuthFlow) {
        this.traverseOAuthFlow(node);
    }

    /**
     * 
     * @param {AaiMessage} node
     */
    public visitMessage(node : AaiMessage) {
        this.traverseMessageBase(node);
        this.traverseCollection(node.oneOf);
        this.traverseCollection(node.traits);
    }

    /**
     * 
     * @param {AaiMessageTrait} node
     */
    public visitMessageTrait(node : AaiMessageTrait) {
        this.traverseMessageBase(node);
    }

    /**
     * 
     * @param {AaiMessageTraitDefinition} node
     */
    public visitMessageTraitDefinition(node : AaiMessageTraitDefinition) {
        this.visitMessageTrait(node);
    }

    /**
     * 
     * @param {OAuthFlows} node
     */
    public visitOAuthFlows(node : OAuthFlows) {
        node.accept(this.visitor);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
        this.traverseIfNotNull(node.implicit);
        this.traverseIfNotNull(node.password);
        this.traverseIfNotNull(node.clientCredentials);
        this.traverseIfNotNull(node.authorizationCode);
    }

    /**
     * 
     * @param {Operation} node
     */
    public visitOperation(node : Operation) {
        node.accept(this.visitor);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
        let aaiNode : AaiOperation = <AaiOperation>node;
        this.traverseOperationBase(aaiNode);
        this.traverseCollection(aaiNode.traits);
        this.traverseIfNotNull(aaiNode.message);
    }

    /**
     * 
     * @param {AaiOperationTrait} node
     */
    public visitOperationTrait(node : AaiOperationTrait) {
        this.traverseOperationBase(node);
    }

    /**
     * 
     * @param {AaiOperationTraitDefinition} node
     */
    public visitOperationTraitDefinition(node : AaiOperationTraitDefinition) {
        this.visitOperationTrait(node);
    }

    /**
     * 
     * @param {PasswordOAuthFlow} node
     */
    public visitPasswordOAuthFlow(node : PasswordOAuthFlow) {
        this.traverseOAuthFlow(node);
    }

    /**
     * 
     * @param {Server} node
     */
    public visitServer(node : Server) {
        node.accept(this.visitor);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
        this.traverseCollection(node.getServerVariables());
        this.traverseCollection((<AaiServer>node).security);
        this.traverseIfNotNull((<AaiServer>node).bindings);
    }

    /**
     * 
     * @param {ServerVariable} node
     */
    public visitServerVariable(node : ServerVariable) {
        node.accept(this.visitor);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    /**
     * 
     * @param {AaiParameter} node
     */
    public visitAaiParameter(node : AaiParameter) {
        node.accept(this.visitor);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
    }

    traverseMessageBase(node : AaiMessageBase) {
        node.accept(this.visitor);
        this.traverseExtensions(node);
        this.traverseValidationProblems(node);
        this.traverseIfNotNull(node.headers);
        this.traverseIfNotNull(node.correlationId);
        this.traverseCollection(node.tags);
        this.traverseIfNotNull(node.externalDocs);
        this.traverseIfNotNull(node.bindings);
    }

    traverseOperationBase(node : AaiOperationBase) {
        node.accept(this.visitor);
        this.traverseOperation(node);
        this.traverseCollection(node.tags);
        this.traverseIfNotNull(node.bindings);
    }

    /**
     * 
     * @param {SecurityScheme} node
     */
    traverseSecurityScheme(node : SecurityScheme) {
        super.traverseSecurityScheme(node);
        let aaiNode : AaiSecurityScheme = <AaiSecurityScheme>node;
        this.traverseIfNotNull(aaiNode.flows);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitServerBindings(io.apicurio.datamodels.asyncapi.models.AaiServerBindings)
     * @param {AaiServerBindings} node
     */
    public visitServerBindings(node : AaiServerBindings) {
        node.accept(this.visitor);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitServerBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiServerBindingsDefinition)
     * @param {AaiServerBindingsDefinition} node
     */
    public visitServerBindingsDefinition(node : AaiServerBindingsDefinition) {
        this.visitServerBindings(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitOperationBindings(io.apicurio.datamodels.asyncapi.models.AaiOperationBindings)
     * @param {AaiOperationBindings} node
     */
    public visitOperationBindings(node : AaiOperationBindings) {
        node.accept(this.visitor);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitOperationBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiOperationBindingsDefinition)
     * @param {AaiOperationBindingsDefinition} node
     */
    public visitOperationBindingsDefinition(node : AaiOperationBindingsDefinition) {
        this.visitOperationBindings(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitMessageBindings(io.apicurio.datamodels.asyncapi.models.AaiMessageBindings)
     * @param {AaiMessageBindings} node
     */
    public visitMessageBindings(node : AaiMessageBindings) {
        node.accept(this.visitor);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitMessageBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiMessageBindingsDefinition)
     * @param {AaiMessageBindingsDefinition} node
     */
    public visitMessageBindingsDefinition(node : AaiMessageBindingsDefinition) {
        this.visitMessageBindings(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitChannelBindings(io.apicurio.datamodels.asyncapi.models.AaiChannelBindings)
     * @param {AaiChannelBindings} node
     */
    public visitChannelBindings(node : AaiChannelBindings) {
        node.accept(this.visitor);
        this.traverseValidationProblems(node);
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor#visitChannelBindingsDefinition(io.apicurio.datamodels.asyncapi.models.AaiChannelBindingsDefinition)
     * @param {AaiChannelBindingsDefinition} node
     */
    public visitChannelBindingsDefinition(node : AaiChannelBindingsDefinition) {
        this.visitChannelBindings(node);
    }
}
AaiTraverser["__class"] = "io.apicurio.datamodels.asyncapi.visitors.AaiTraverser";
AaiTraverser["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.core.visitors.ITraverser"];





import { IAaiVisitor } from './IAaiVisitor';

